require.context('favicon', true)
require.context('../images', true)
